export type RegularSessionBounds = {
  startIndex: number;
  endIndex: number;
};

export type SessionSegment = {
  start: number;
  end: number;
  isRegular: boolean;
};

export const getSessionSegments = (totalPoints: number, bounds?: RegularSessionBounds): SessionSegment[] => {
  const lastIndex = totalPoints - 1;
  if (lastIndex < 0) return [];

  const wholeLine: SessionSegment = { start: 0, end: lastIndex, isRegular: true };
  if (!bounds) return [wholeLine];

  const start = Math.max(0, Math.min(bounds.startIndex, lastIndex));
  const end = Math.max(start, Math.min(bounds.endIndex, lastIndex));
  const hasRegularSession = bounds.startIndex <= lastIndex;

  const segments: SessionSegment[] = [];
  if (start > 0) segments.push({ start: 0, end: start, isRegular: false });
  if (hasRegularSession) segments.push({ start, end, isRegular: true });
  if (end < lastIndex) segments.push({ start: end, end: lastIndex, isRegular: false });

  return segments;
};

export type SessionKind = 'preMarket' | 'regular' | 'afterHours';

export const getSessionKind = (index: number, bounds: RegularSessionBounds): SessionKind => {
  if (index < bounds.startIndex) return 'preMarket';
  if (index > bounds.endIndex) return 'afterHours';
  return 'regular';
};

export const findHoveredSegment = (segments: SessionSegment[], index: number): SessionSegment | undefined => {
  const contains = (segment: SessionSegment) => index >= segment.start && index <= segment.end;

  return segments.find(segment => segment.isRegular && contains(segment)) ?? segments.find(contains);
};
